const useIsDemo = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const isDemo = searchParams.get("demo") === "true";
  const demoEmail = searchParams.get("email") || "";
  return { isDemo, demoEmail };
};

export default useIsDemo;
